import React, { Component } from 'react';
import PropTypes from 'prop-types';
import texts from '../texts/statusMessages';

export default class MessageBox extends Component {

    static propTypes = {
        lang: PropTypes.string.isRequired,
        statusCode: PropTypes.number.isRequired
    };

    render() {
        let messageType = {
            0: 'info',
            100: 'info',
            101: 'warning',
            102: 'warning',
            103: 'warning',
            200: 'success',
            201: 'warning',
            202: 'danger',
            203: 'warning',
            204: 'warning',
            300: 'success',
            301: 'warning',
            302: 'warning',
            303: 'warning',
            400: 'success',
            401: 'warning',
            402: 'warning',
            403: 'warning',
            410: 'success',
            411: 'warning',
            412: 'warning',
            413: 'warning',
            414: 'warning',
            415: 'warning',
            416: 'warning',
            600: 'success',// Uživatel v pořádku ověřen
            601: 'warning',// Neexistující uživatel
            602: 'warning',// Uživatel má zablokovaný účet.
            603: 'warning',// Uživatel nemá registrované mobilní číslo
            604: 'warning',// Uzamčená IP uživatele
            700: 'success',//'Ověření RC proběhlo v pořádku, na mobilní telefon byl zaslán ověřovací kód',
            701: 'warning',//'Ověření RC proběhlo v pořádku, nebyl nalezen registrovaný telefon',
            702: 'warning',//'Ověření RC proběhlo v pořádku, při odeslání SMS se vyskytla chyba.',
            803: 'warning',// Pro tohoto uživatele je služba zasílání SMS momentálně uzamčena,
            800: 'success',// Ověření proběhlo v pořádku, je možno zaslat nové heslo
            801: 'danger',// Token pro ověření SMS kódu neexistuje nebo vypršela jeho platnost
            802: 'danger'// SMS kód neodpovídá zaslanému kódu
            };
        let text = texts[this.props.lang];

        return (
             <div className={'alert alert-' + messageType[this.props.statusCode]}>
                <span className="glyphicon glyphicon-ok" aria-hidden="true"></span>
                &nbsp;{text[this.props.statusCode]}
              </div>
            );
  }
}
